import http from '../../../../api/http'

// 온라인 특별채용관 현황 리스트
function ojfListByCorpId(paramObj) {
    return http.post('/mypage/ojf/onlineJobFair/retrieveOjfPagingByCorpId', {
        searchOjfStateGb: paramObj.searchOjfStateGb || "01,02,03,04", // 01,02,03,04
        searchJoinStateGb: paramObj.searchJoinStateGb || "01,02,03,04,11,21", // 01,02,03,04,11,21
        pageNumber: paramObj.pageNumber || 0, // 0
        size: paramObj.size || 30,
        userId: paramObj.userId, // 0
    });
}

// 온라인 특별채용관 현황 상세 상단 정보
function ojfDetailByIdAndCorpIdForMyPage(id) {
    return http.get(`/mypage/ojf/onlineJobFair/retrieveOjfByOjfIdAndCorpIdForMyPage?ojfId=${id}`);
}

// 기업정보 관리 조회
function ojfCorporationDetail(id) {
    return http.get(`/mypage/ojf/corporation/retrieveCorporation?corpId=${id}`);
}

// 기업 정보 등록 및 참가 신청
function ojfCropCreateRecruitmentHall(paramObj) {
    return http.post('/mypage/ojf/recruitmentHall/createRecruitmentHall', {
        ojfId: paramObj.ojfId,
        bizNum: paramObj.bizNum, // 사업자등록번호
        corpName: paramObj.corpName, // 기업명
        ceoName: paramObj.ceoName, // 대표자명
        residenceArea1: paramObj.residenceArea1, // 사업장소재지1
        residenceArea2: paramObj.residenceArea2, // 사업장소재지2
        bizType: paramObj.bizType, // 업종
        industryGb: paramObj.industryGb, // 산업군
        industryText: paramObj.industryText, // 사업군 기타
        corpGb: paramObj.corpGb, // 기업형태
        corpText: paramObj.corpText, // 기업형태 기타
        foundYm: paramObj.foundYm, // 창립연월
        employeeNumGb: paramObj.employeeNumGb, // 인원구분(사원수)
        salesAmtGb: paramObj.salesAmtGb, // 매출액
        corpPublicYn: paramObj.corpPublicYn, // 상장여부
        corpPublicGb: paramObj.corpPublicGb, // 상장구분
        corpPublicText: paramObj.corpPublicText, // 상장구분 기타
        homeUrl: paramObj.homeUrl, // 홈페이지
        ciImgName: paramObj.ciImgName, // 로고이미지명
        ciImgSize: paramObj.ciImgSize, // 로고이미지용량
        ciImgDir: paramObj.ciImgDir, // 로고이미지위치
        bizLicenseName: paramObj.bizLicenseName, // 사업자등록증명
        bizLicenseSize: paramObj.bizLicenseSize, // 사업자등록증용량
        bizLicenseDir: paramObj.bizLicenseDir, // 사업자등록증위치
        corpIntro: paramObj.corpIntro, // 기업소개
        corpHistory: paramObj.corpHistory, // 주요연혁
        corpIntroName: paramObj.corpIntroName, // 기업소개서명
        corpIntroSize: paramObj.corpIntroSize, // 기업소개서용량
        corpIntroDir: paramObj.corpIntroDir, // 기업소개서위치
        joinPurpose: paramObj.joinPurpose, // 참가 목적
        intvInYn: paramObj.intvInYn, // 면접 가능 유무
        intvAbleDay: paramObj.intvAbleDay, // 면접가능일
        intvGb: paramObj.intvGb, // 면접방식
        fileYn: paramObj.fileYn, // 회사이력서파일유무
        corpResumeAttaches: paramObj.corpResumeAttaches, // 회사이력서파일
        recruitCnt: paramObj.recruitCnt, // 모집인원
        chargeName: paramObj.chargeName, // 참가신청 담당자 성명
        chargeDepart: paramObj.chargeDepart, // 참가신청 담당자 부서
        chargeJob: paramObj.chargeJob, // 참가신청 담당자 직위
        chargeCompanyNum: paramObj.chargeCompanyNum, // 참가신청 담당자 회사 직통번호
        chargePhoneNum: paramObj.chargePhoneNum, // 참가신청 담당자 휴대전화
        chargeEmail: paramObj.chargeEmail, // 참가신청 담당자 이메일
        agreePrivacyYn: paramObj.agreePrivacyYn, // 약관동의유무
    })
}

// 기업 정보 수정
function ojfUpdateCorporation(
    corpId, bizNum, corpName, ceoName, residenceArea1, residenceArea2,
    bizType, industryGb, industryText, corpGb, corpText,
    foundYm, employeeNumGb, salesAmtGb, corpPublicYn, corpPublicGb, corpPublicText,
    homeUrl, ciImgName, ciImgSize, ciImgDir,
    bizLicenseName, bizLicenseSize, bizLicenseDir,
    corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir,
) {
    return http.post('/mypage/ojf/corporation/updateCorporation', {
        corpId,
        bizNum, // 사업자등록번호
        corpName, // 기업명
        ceoName, // 대표자명
        residenceArea1, // 사업장소재지1
        residenceArea2, // 사업장소재지2
        bizType, // 업종
        industryGb, // 산업군
        industryText, // 사업군 기타
        corpGb, // 기업형태
        corpText, // 기업형태 기타
        foundYm, // 창립연월
        employeeNumGb, // 인원구분(사원수)
        salesAmtGb, // 매출액
        corpPublicYn, // 상장여부
        corpPublicGb, // 상장구분
        corpPublicText, // 상장구분 기타
        homeUrl, // 홈페이지
        ciImgName, // 로고이미지명
        ciImgSize, // 로고이미지용량
        ciImgDir, // 로고이미지위치
        bizLicenseName, // 사업자등록증명
        bizLicenseSize, // 사업자등록증용량
        bizLicenseDir, // 사업자등록증위치
        corpIntro, // 기업소개
        corpHistory, // 주요연혁
        corpIntroName, // 기업소개서명
        corpIntroSize, // 기업소개서용량
        corpIntroDir, // 기업소개서위치
    })
}

// 참가 신청 정보 수정
function ojfCropUpdateRecruitmentHall(
    recruitmentHallSeq,
    joinPurpose, intvInYn, intvAbleDay, intvGb,
    fileYn, corpResumeAttaches, recruitCnt,
    chargeName, chargeDepart, chargeJob, chargeCompanyNum,
    chargePhoneNum, chargeEmail, agreePrivacyYn,
) {
    return http.post('/mypage/ojf/recruitmentHall/updateRecruitmentHall', {
        recruitmentHallSeq,
        joinPurpose, // 참가 목적
        intvInYn, // 면접 가능 유무
        intvAbleDay, // 면접가능일
        intvGb, // 면접방식
        fileYn, // 회사이력서파일유무
        corpResumeAttaches, // 회사이력서파일
        recruitCnt, // 모집인원
        chargeName, // 참가신청 담당자 성명
        chargeDepart, // 참가신청 담당자 부서
        chargeJob, // 참가신청 담당자 직위
        chargeCompanyNum, // 참가신청 담당자 회사 직통번호
        chargePhoneNum, // 참가신청 담당자 휴대전화
        chargeEmail, // 참가신청 담당자 이메일
        agreePrivacyYn, // 약관동의유무
    })
}

// 기업 정보 등록 및 참가 신청 취소
function ojfCropDeleteRecruitmentHall(recruitmentHallSeq) {
    return http.post('/mypage/ojf/recruitmentHall/deleteRecruitmentHall', {
        recruitmentHallSeq, // 0
    })
}

// 참가신청 정보 관리 조회
function ojfCorpRecruitmentHall(paramObj) {
    return http.get(`/mypage/ojf/recruitmentHall/retrieveRecruitmentHall?ojfId=${paramObj.ojfId}&corpId=${paramObj.corpId}`);
}

// 참가 신청 할 떄, 참가 신청 여부 확인
function ojfCorpRecruitmentHall2(paramObj) {
    return http.get(`/mypage/ojf/recruitmentHall/retrieveRecruitmentHall2?ojfId=${paramObj.ojfId}&corpId=${paramObj.corpId}`);
}

// 채용공고 목록 조회
function ojfCropJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/jobNotice/retrieveCorpJobNoticeListPaging', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        resumeId: paramObj.resumeId, //0,
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 채용공고 등록
function ojfCropJobNoticeCreate(
    ojfId, jobName,
    interests, job, recruitArea, recruitCnt,
    jobExperience, schoolGb, specialTreat,
    workArea1, workArea2, workHomeYn, workType,
    salaryGb, salary, note,
) {
    return http.post('/mypage/ojf/jobNotice/createJobNotice', {
        ojfId, // 0
        jobName, // 공고명
        interests, // 관심 카테고리
        job, // 직무
        recruitArea, // 모집분야명
        recruitCnt, // 모집인원
        jobExperience, // 경력
        schoolGb, // 학력
        specialTreat, // 우대사항(자격증)
        workArea1, // 근무지역_시도
        workArea2, // 근무지역_시군구
        workHomeYn, // 재택가능여부
        workType, // 근무형태
        salaryGb, // 급여구분
        salary, // 급여
        note, // 기타요건
    })
}

// 채용공고 조회
function ojfCropJobNoticeDetail(paramObj) {
    return http.get(`/mypage/ojf/jobNotice/retrieveJobNotice?jobNoticeSeq=${paramObj.jobNoticeSeq}`);
}

// 채용공고 수정
function ojfCropJobNoticeUpdate(
    jobNoticeSeq, jobName,
    interests, job, recruitArea, recruitCnt,
    jobExperience, schoolGb, specialTreat,
    workArea1, workArea2, workHomeYn, workType,
    salaryGb, salary, note,
) {
    return http.post('/mypage/ojf/jobNotice/updateJobNotice', {
        jobNoticeSeq, // 0
        jobName, // 공고명
        interests, // 관심 카테고리
        job, // 직무
        recruitArea, // 모집분야명
        recruitCnt, // 모집인원
        jobExperience, // 경력
        schoolGb, // 학력
        specialTreat, // 우대사항(자격증)
        workArea1, // 근무지역_시도
        workArea2, // 근무지역_시군구
        workHomeYn, // 재택가능여부
        workType, // 근무형태
        salaryGb, // 급여구분
        salary, // 급여
        note, // 기타요건
    })
}

// 채용 공고 삭제
function ojfCropJobNoticeDelete(jobNoticeSeq) {
    return http.post('/mypage/ojf/jobNotice/deleteJobNotice', {
        jobNoticeSeq, // 0
    })
}

// 입사지원 목록 조회
function ojfCropRetrieveApplicantList(paramObj) {
    return http.post('/mypage/ojf/applicant/retrieveApplicantListPagingByJobNoticeSeq', {
        ojfId: paramObj.ojfId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
        resumeId: paramObj.resumeId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 인재 목록 조회
function ojfCropInterestEntryList(paramObj) {
    return http.post('/mypage/ojf/interestHallEntry/retrieveInterestHallEntryListPaging', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
    })
}

// 관심 인재 삭제
function ojfCropInterestEntryYn(paramObj) {
    return http.post('/mypage/ojf/interestHallEntry/updateCorpInterestHallEntryYn', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        resumeId: paramObj.resumeId, // 0
        interestYn: paramObj.interestYn, // string
        userId: paramObj.userId, // 0
        requestUserId: paramObj.requestUserId, // 0
    })
}

// 면접제안 count (0이면 제안한적 없음, 0초과면 제안이 있는)
function ojfCropInterviewProposalEntryCnt(paramObj) {
    return http.get(`/mypage/ojf/interviewProposalEntry/retrieveInterviewProposalEntryCnt?ojfId=${paramObj.ojfId}&corpId=${paramObj.corpId}&resumeId=${paramObj.resumeId}`);
}

// 면접제안 시 채용공고 목록
function ojfCropInterviewProposalJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/jobNotice/retrieveJobNoticeListPagingWithResumeId', {
        ojfId: paramObj.ojfId, // 0
        resumeId: paramObj.resumeId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
    })
}

// 면접제안 등록
function ojfCropInterviewProposalCreate(paramObj) {
    return http.post('/mypage/ojf/interviewProposalEntry/createInterviewProposalEntry', {
        ojfId: paramObj.ojfId, // 0
        resumeId: paramObj.resumeId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
    })
}

// 면접 제안 목록
function ojfCropInterviewProposalList(paramObj) {
    return http.post('/mypage/ojf/interviewProposalEntry/retrieveCorpInterviewProposalEntryListPaging', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        resumeId: paramObj.resumeId, // 0
        interestYn: paramObj.interestYn, // string
        userId: paramObj.userId, // 0
        requestUserId: paramObj.requestUserId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
    })
}

// 참가 확정 모달 유무 조회 - 기업
function ojfRecruitmentHallApproveModal() {
    return http.get(`/mypage/ojf/recruitmentHall/retrieveRecruitmentHallApproveModal`);
}

// 참가 확정 모달 행사 정보 확인
function ojfUpdateRecruitmentHallApproveYn(recruitmentHallSeq) {
    return http.post(`/mypage/ojf/recruitmentHall/updateRecruitmentHallApproveYn`, {
        recruitmentHallSeq,
    });
}

// 입사지원 엑셀 다운로드
function ojfCorpUserResumeExcel(paramObj) {
    return http.post('/mypage/ojf/applicant/retrieveApplicantListExcelByJobNoticeSeq', {
        ojfId: paramObj.ojfId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
    }, {
        responseType: 'blob',
    })
}

export default {
    ojfListByCorpId, // 온라인 특별채용관 현황 리스트
    ojfDetailByIdAndCorpIdForMyPage, // 온라인 특별채용관 현황 상세 상단 정보
    ojfCorporationDetail, // 기업정보 관리 조회
    ojfCropCreateRecruitmentHall, // 기업 정보 등록 및 참가 신청
    ojfUpdateCorporation, // 기업 정보 수정
    ojfCropUpdateRecruitmentHall, // 참가 신청 정보 수정
    ojfCropDeleteRecruitmentHall, // 참가 신청 취소
    ojfCorpRecruitmentHall, // 참가신청 정보 관리 조회
    ojfCorpRecruitmentHall2, // 참가신청시 참가신청 여부 확인
    ojfCropJobNoticeList, // 채용공고 목록 조회
    ojfCropJobNoticeCreate, // 채용공고 등록
    ojfCropJobNoticeDetail, // 채용공고 조회
    ojfCropJobNoticeUpdate, // 채용공고 수정
    ojfCropJobNoticeDelete, // 채용공고 삭제
    ojfCropRetrieveApplicantList, // 입사지원 목록 조회
    ojfCropInterestEntryList, // 관심 인재 목록 조회
    ojfCropInterestEntryYn, // 관심 인재 삭제
    ojfCropInterviewProposalEntryCnt, // 면접제안 count
    ojfCropInterviewProposalJobNoticeList, // 면접제안 시 채용공고 목록
    ojfCropInterviewProposalCreate, // 면접제안 등록
    ojfCropInterviewProposalList, // 면접 제안 목록
    ojfRecruitmentHallApproveModal, // 참가 확정 모달 유무 조회 - 기업
    ojfUpdateRecruitmentHallApproveYn, // 참가 확정 모달 행사 정보 확인
    ojfCorpUserResumeExcel, // 입사지원 엑셀 다운로드
};